import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import YoutubeVideoCard from 'components/Indoor_Cameras/IN-8015_HD/Usermanual/YoutubeVideoCard';
import NavButtons from 'components/Indoor_Cameras/IN-8015_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  YoutubeVideoCard,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};